module.exports = __webpack_public_path__ + "img/katarina_kitchen_8.425986d1.jpg";